export interface ISmartResultGridCoverage{	 	
	// processing_company:string,
	// processing_iteration:number,
	// processing_mode:string,
	// processing_name:string,
	wpts:Array<{id:number,wpt_label:string,wpt_lat:number,wpt_lon:number}>,
}

export function getDefaultSmartResultGridCoverage({/*processing_company="",processing_iteration=0,processing_mode='', processing_name='',*/ wpts=[] as Array<{id:number,wpt_label:string,wpt_lat:number,wpt_lon:number}>}={}):ISmartResultGridCoverage {
	return {		
		// processing_company,
		// processing_iteration,
		// processing_mode,
		// processing_name,
		wpts
	} 
}